import React, { useState } from "react";
import "./DashboardMenu.css";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import AccountCircle from "@material-ui/icons/AccountCircle";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import CloseIcon from "@material-ui/icons/Close";
import { Link } from "react-router-dom";
import Registration from "../../Registration/Registration";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  navColor: {
    backgroundColor: "#DCE5F1",
    color: "#222",
    boxShadow: "none",
    position: "fixed",
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  subTitle: {
    fontSize: 14,
    fontWeight: 700,
  },
}));

const Navbar = ({ isShaws, setIsShaws }) => {
  console.log(isShaws);
  const classes = useStyles();
  const [auth, setAuth] = React.useState(true);
  const [modelOpen, setModelOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleModelOpen = () => {
    setModelOpen(true);
  };

  const handleModelClose = () => {
    setModelOpen(false);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static" className={classes.navColor}>
        <Toolbar>
          {isShaws ? (
            <IconButton
              edge="start"
              className={classes.menuButton}
              color="inherit"
              aria-label="menu"
              onClick={() => setIsShaws(false)}
            >
              <MenuIcon />
            </IconButton>
          ) : (
            <IconButton
              edge="start"
              className={classes.menuButton}
              color="inherit"
              aria-label="menu"
              onClick={() => setIsShaws(true)}
            >
              <CloseIcon />
            </IconButton>
          )}

          <Typography variant="h6" className={classes.title}></Typography>
          {auth && (
            <div className="dashBoardMenu">
              <Typography variant="h6" className={classes.subTitle}>
                <Link className={classes.subTitle}>
                  <IconButton color="inherit">
                    <AccountCircle />
                    <button type="button" onClick={handleModelOpen}>
                      ABC LLC
                    </button>
                  </IconButton>

                  <Registration
                    modelOpen={modelOpen}
                    setModelOpen={setModelOpen}
                    handleModelOpen={handleModelOpen}
                    handleModelClose={handleModelClose}
                  />
                </Link>
              </Typography>
              <Typography variant="h6" className={classes.subTitle}>
                <Link
                  to="/request-a-quote"
                  className={classes.subTitle}
                  style={{ width: "100%" }}
                >
                  <IconButton color="inherit" className="navLink ">
                    Request a Quote
                  </IconButton>
                </Link>
              </Typography>

              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={open}
                onClose={handleClose}
              >
                <MenuItem onClick={handleClose}>Profile</MenuItem>
                <MenuItem onClick={handleClose}>My account</MenuItem>
              </Menu>
            </div>
          )}
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default Navbar;
